﻿import _ from 'lodash';
import React from "react";
import { Pagination } from '@mui/material';
import { FormControl, Select, MenuItem, ListSubheader, Menu } from '@mui/material';

import SearchResultItem from './SearchResultItem';

export default class Search extends React.Component {
    constructor(props) {
        super(props);
        this.eventregisterd = false;
        this.data = props.data;
        this.showFacets = true;
        this.debouncedfoo = _.debounce(this.loadData, 1000);
        let currentYear = new Date().getFullYear();
        let array = _.range(currentYear, currentYear - 25, -1).map((i) => i.toString());
        this.fromyearvalues = ["", ...array];
        this.toyearvalues = this.fromyearvalues;

        this.state = {
            Filters: {
                firmanavn: props.data.firmanavn,
                orderby: props.data.Orderby,
                partgroup: props.data.SearchResults.PartGroup,
                part: props.data.SearchResults.PartGroup && props.data.SearchResults.Parts && props.data.SearchResults.Parts[0],
                brand: props.data.SearchResults.Brand,
                models: props.data.SearchResults.Brand && props.data.SearchResults.Models && props.data.SearchResults.Models[0],
                price: props.data.SearchResults.Price,
                fromyear: props.data.SearchResults.FromYear,
                toyear: props.data.SearchResults.ToYear,
                haspictures: props.data.SearchResults.haspcitures ?? props.data.SearchResults.haspictures,
                mileage: props.data.SearchResults.Mileage,
                start: props.data.CurrentPageIndex,
                type: props.data.SearchType,
                q: props.data.SearchText,
            },
            fromYearOpen: false,
            toYearOpen: false,
            sortDropdownAnchorEl: null,
            isFiltersVisible: false,
            screenWidth: window.innerWidth,
            TotalResults: props.data.SearchResults.TotalRows,
            PartFacets: props.PartFacets,
            BrandFacets: props.BrandFacets,
            showFacets: false,
            SearchResults: props.data.SearchResults.Results,
            isLoading: false,
            NumResults: props.data.NumResultPages,
            Firmanavn: props.data.firmanavn,
            Top10Parts: props.data.Top10Parts,
            Alphabetic: this.alphabethize(props.PartFacets.map(i => i.ChildPivots)),
            showAlpha: false
        };

        //console.dir(props.data);
    }

    alphabethize(partfacets) {
        var flattened = partfacets.flat();
        var alphabethic = {};
        for (let i = 0; i < flattened.length; i++) {

            let firstLetter = flattened[i].Value.charAt(0).toUpperCase();
            if (alphabethic[firstLetter] == null) {
                alphabethic[firstLetter] = [flattened[i]];
            }
            else alphabethic[firstLetter].push(flattened[i]);
        }
        return alphabethic;
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateScreenWidth);
        var forms = document.querySelector("form.searchform");
        if (forms) {
            for (var j = 0; j < forms.length; j++) {
                forms[j].addEventListener("submit",
                    (a, b, c) => {
                        var data = $(a.target).serializeArray();
                        //console.dir(data);
                        a.preventDefault();
                        this.performTextSearch(data.find(i => i.name === "q").value,
                            data.find(i => i.name === "type") && data.find(i => i.name === "type").value);
                    });
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScreenWidth);
    }

    updateScreenWidth = () => {
        this.setState({ screenWidth: window.innerWidth });
    };

    showAlpha = (flag) => {
        this.setState({
            ...this.state,
            showAlpha: flag
        });
    };

    performTextSearch = (q, type) => {
        if (type == undefined)
            type = "";
        // hent data

        this.setState({
            Filters: {
                ...this.state.Filters,
                q: q,
                type: type
            }
        });

        let data = {
            ...this.state,
            start: 1,
            isLoading: true,
            Filters: {
                ...this.state.Filters,
                q: q,
                type: type
            }
        };

        this.setState(data,
            this.loadData("q", true, false));
    }

    bah = (a, fieldname, event, value) => {
        let isupwards = false;
        let valuetouse = value || a.Value;

        let scrolltop = fieldname === "start";

        if (this.state.Filters[fieldname] !== valuetouse) {

            if (fieldname === "models" || fieldname === "brand") {
                this.state.Top10Parts = null;
            }

            // hent data

            let data = {
                ...this.state,
                isLoading: true,
                Filters: {
                    ...this.state.Filters,
                    [fieldname]: valuetouse,
                }
            };

            if (fieldname !== "start")
                data.Filters.start = 1;

            this.setState(data,
                this.loadData(fieldname, isupwards, scrolltop));

        } else {
            isupwards = true;
            if (fieldname === "partgroup") {
                this.state.Filters.part = "";
            }
            if (fieldname === "brand") {
                this.state.Filters.models = "";
            }

            let data = {
                ...this.state,
                isLoading: true,
                Filters: {
                    ...this.state.Filters,
                    [fieldname]: "",
                }
            };

            if (fieldname !== "start")
                data.Filters.start = 1;

            this.setState(data,
                this.loadData('searchtext', isupwards, scrolltop));
        }
    }

    togglePopularPart = (fieldname, fieldvalues, e) => {

        let isupwards = false;
        let scrolltop = fieldname === "start";

        if (this.state.Filters[fieldname] !== fieldvalues[fieldname]) {

            // hent data

            let data = {
                ...this.state,
                isLoading: true,
                Filters: {
                    ...this.state.Filters,
                    ["brand"]: fieldvalues["brand"],
                    ["models"]: fieldvalues["models"],
                    ["partgroup"]: fieldvalues["partgroup"],
                    ["part"]: fieldvalues["part"]
                }
            };

            if (fieldname !== "start")
                data.Filters.start = 1;

            this.setState(data,
                this.loadData(fieldname, isupwards, scrolltop));

        } else {
            isupwards = true;
            if (fieldname === "partgroup") {
                this.state.Filters.part = "";
            }
            if (fieldname === "brand") {
                this.state.Filters.models = "";
            }

            let data = {
                ...this.state,
                isLoading: true,
                Filters: {
                    ...this.state.Filters,
                    [fieldname]: "",
                }
            };

            if (fieldname !== "start")
                data.Filters.start = 1;

            this.setState(data,
                this.loadData('searchtext', isupwards, scrolltop));
        }
    }

    loadData = (fieldname, isupwards, scrolltop) => {
        return function () {
            var url = window.location.href.split('?')[0];
            var data = new URLSearchParams(_.pickBy(this.state.Filters, _.identity)).toString();
            if (scrolltop) {
                document.getElementById('partlist').scrollIntoView();
            }
            var that = this;
            $.ajax('/api/Search/Index/?' + data).then((result) =>
                that.setState((prev) => {
                    var returnData = {
                        SearchResults: result.SearchResults.Results,
                        isLoading: false,
                        TotalResults: result.SearchResults.TotalRows,
                        NumResults: result.NumResultPages,
                        Top10Parts: result.Top10Parts
                    };

                    if ((fieldname === "brand" || fieldname === "models") || isupwards) {
                        returnData.PartFacets = result.SearchResults.PartFacets;
                        returnData.Alphabetic = this.alphabethize(returnData.PartFacets.map(j => j.ChildPivots));
                    }
                    if ((fieldname === "part" || fieldname === "partgroup") || isupwards) {
                        returnData.BrandFacets = result.SearchResults.ModelFacets;
                    }

                    return returnData;
                },
                    (beh) => {
                        console.log("Statae being pushed:", this.state);
                        const { sortDropdownAnchorEl, ...stateWithoutAnchorEl } = this.state;

                        history.pushState(stateWithoutAnchorEl, 'orderby:' + this.state.OrderBy, url + "?" + data);
                        if (scrolltop)
                            document.getElementById('partlist').scrollIntoView();
                    }
                ),
                (meh) => console.log('error')
            );

            if (this.eventregisterd === false) {
                window.addEventListener('popstate', (evt) => {

                    console.info("State: ", evt.state);
                    this.setState(evt.state);
                });
                this.eventregisterd = true;
            }
        };
    };

    debouncedbobByName = (e, fieldname) => {
        const { target: { name, value } } = e;
        this.setState({
            Filters: {
                ...this.state.Filters,
                [name]: e.target.value
            }
        });
    };

    setHasPicturesFilter = (e) => {
        let value = null;
        if (e.target.checked) {
            value = "true";
        }
        this.setState({
            Filters: {
                ...this.state.Filters,
                haspictures: value
            }
        });
    };

    bobByName = (e, fieldname) => {
        const { target: { name, value } } = e;
        this.setState({
            Filters: {
                ...this.state.Filters,
                [fieldname]: e.target.value
            }
        });

    };

    setOrderBy = (sortOrder) => {
        this.setState({
            Filters: {
                ...this.state.Filters,
                "orderby": sortOrder
            }
        }, this.loadData("orderby", true));

    };

    toggleFacets = (e) => {
        if (this.state.showFacets === true) {
            document.body.classList.remove('compress');
        }
        else {
            document.body.classList.add('compress');
        }
        this.setState({
            showFacets: !this.state.showFacets
        });
    }

    activateFilter = async () => {
        console.log("Activating filter...");

        var url = window.location.href.split('?')[0];
        var data = new URLSearchParams(_.pickBy(this.state.Filters, _.identity)).toString();

        var that = this;
        $.ajax('/api/Search/Index/?' + data).then((result) =>
            that.setState((prev) => {
                var returnData = {
                    SearchResults: result.SearchResults.Results,
                    isLoading: false,
                    TotalResults: result.SearchResults.TotalRows,
                    NumResults: result.NumResultPages,
                    Top10Parts: result.Top10Parts
                };

                returnData.PartFacets = result.SearchResults.PartFacets;
                returnData.Alphabetic = this.alphabethize(returnData.PartFacets.map(j => j.ChildPivots));

                returnData.BrandFacets = result.SearchResults.ModelFacets;

                return returnData;
            },
                (beh) => {
                    history.pushState(this.state, 'orderby:' + this.state.OrderBy, url + "?" + data)
                }
            ),
            (meh) => console.log('error')
        );

        if (this.eventregisterd === false) {
            window.addEventListener('popstate', (evt) => {

                console.info("State: ", evt.state);
                this.setState(evt.state);
            });
            this.eventregisterd = true;
        }
    }

    render() {
        const { isFiltersVisible, screenWidth } = this.state;
        const shouldRenderFilters = screenWidth < 870 ? isFiltersVisible : true;

        return (
            <div className='choosePartContentWrapper'>
                <div className="filterContainer">
                    <h2 className='partDetailsFilterText' onClick={() => this.setState({ isFiltersVisible: !this.state.isFiltersVisible })}>
                        <div>
                            <img className="partDetailsFilterIcon" src="/images/filter.svg" />
                            Begrens antall treff
                        </div>
                        <img className='partDetailsFilterIcon' src={this.state.isFiltersVisible ? "/images/CaretUpSmall.svg" : "/images/CaretDown.svg"} />
                    </h2>
                    {shouldRenderFilters && (
                        <div className="searchFilters">
                            <label for="milage">Max km stand</label>
                            <div className="filterInput">
                                <input className='partDetailsFilterInput' onChange={(e) => this.debouncedbobByName(e, 'mileage')} type="text" name="mileage" id='milage' value={this.state.Filters.mileage} />
                                <span className="filterUnit">km</span>
                            </div>
                            <label for="fromyear">Årsmodell</label>
                            <div className="filterInput" onClick={() => this.setState({ fromYearOpen: !this.state.fromYearOpen })}>
                                <FormControl variant="outlined" fullWidth>
                                    <Select
                                        className='partDetailsFilterInput'
                                        id="fromyear"
                                        value={this.state.Filters.fromyear}
                                        onChange={(e) => this.bobByName(e, 'fromyear')}
                                        sx={{
                                            fontSize: '16px'
                                        }}
                                        IconComponent={() => null}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                                return <>Fra år</>;
                                            }
                                            return selected;
                                        }}
                                        open={this.state.fromYearOpen}
                                    >
                                        <MenuItem value="" disabled>
                                            Fra år
                                        </MenuItem>
                                        {this.fromyearvalues.map((item) => (
                                            <MenuItem sx={{ fontSize: "16px" }} key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <img className="filterDropdownIcon" src="/images/CaretDown.svg" />
                            </div>
                            <div className="filterInput" onClick={() => this.setState({ toYearOpen: !this.state.toYearOpen })}>
                                <FormControl variant="outlined" fullWidth>
                                    <Select
                                        className='partDetailsFilterInput'
                                        id="toyear"
                                        value={this.state.Filters.toyear}
                                        onChange={(e) => this.bobByName(e, 'toyear')}
                                        sx={{
                                            fontSize: '16px'
                                        }}
                                        IconComponent={() => null}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                                return <>Til år</>;
                                            }
                                            return selected;
                                        }}
                                        open={this.state.toYearOpen}
                                    >
                                        <MenuItem value="" disabled>
                                            Til år
                                        </MenuItem>
                                        {this.fromyearvalues.map((item) => (
                                            <MenuItem sx={{ fontSize: "16px" }} key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <img className="filterDropdownIcon" src="/images/CaretDown.svg" />
                            </div>

                            <div className="partDetailsPictureFilterContainer">
                                <input
                                    onClick={(e) => this.setHasPicturesFilter(e)}
                                    type="checkbox" name="haspictures"
                                    id='haspictures'
                                    checked={this.state.Filters.haspictures}
                                />
                                <label htmlFor="haspictures">Har bilder</label>
                            </div>
                            <div className="activateFiltersWrapper">
                                <button className='partDetailsFilterActivateButton' onClick={(e) => this.activateFilter()}>Aktiver filter</button>
                            </div>
                        </div>
                    )}
                </div>

                <div className='partDetailsSearchResultsWrapper'>
                    <div className="partDetailsHitsAndSortingContainer">
                        <h3 className='partDetailsNumberHits'>{this.state.TotalResults} treff </h3>

                        <div className="partDetailsSortWrapper">
                            <p>Sortering</p>
                            <img
                                src="/images/sort.svg"
                                onClick={(event) => this.setState({ sortDropdownAnchorEl: event.currentTarget })}
                                style={{ cursor: 'pointer' }}
                            />
                            <Menu
                                anchorEl={this.state.sortDropdownAnchorEl}
                                open={Boolean(this.state.sortDropdownAnchorEl)}
                                onClose={() => this.setState({ sortDropdownAnchorEl: null })}
                            >
                                <ListSubheader sx={{ fontSize: "16px" }}>Årsmodell</ListSubheader>
                                <MenuItem sx={{ fontSize: "16px" }} value="CarYearModel" onClick={() => { this.setOrderBy('CarYearModel'); this.setState({ sortDropdownAnchorEl: null }); }}>Årsmodell nyest - eldst</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="CarYearModelAsc" onClick={() => { this.setOrderBy('CarYearModelAsc'); this.setState({ sortDropdownAnchorEl: null }); }}>Årsmodell eldst - nyest</MenuItem>
                                <ListSubheader sx={{ fontSize: "16px" }}>Kilometerstand</ListSubheader>
                                <MenuItem sx={{ fontSize: "16px" }} value="Mileage" onClick={() => { this.setOrderBy('Mileage'); this.setState({ sortDropdownAnchorEl: null }); }}>Kilometerstand - lavest først</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="MileageDesc" onClick={() => { this.setOrderBy('MileageDesc'); this.setState({ sortDropdownAnchorEl: null }); }}>Kilometerstand - høyest først</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="OriginalNumber" onClick={() => { this.setOrderBy('OriginalNumber'); this.setState({ sortDropdownAnchorEl: null }); }}>Originalnummer</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="ArticleNumber" onClick={() => { this.setOrderBy('ArticleNumber'); this.setState({ sortDropdownAnchorEl: null }); }}>Artikkelnummer</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="EngineType" onClick={() => { this.setOrderBy('EngineType'); this.setState({ sortDropdownAnchorEl: null }); }}>Motor</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="Color" onClick={() => { this.setOrderBy('Color'); this.setState({ sortDropdownAnchorEl: null }); }}>Farge</MenuItem>
                                <ListSubheader sx={{ fontSize: "16px" }}>Bedrift</ListSubheader>
                                <MenuItem sx={{ fontSize: "16px" }} value="DealerName" onClick={() => { this.setOrderBy('DealerName'); this.setState({ sortDropdownAnchorEl: null }); }}>Bedrift - alfabetisk stigende</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="DealerNameDesc" onClick={() => { this.setOrderBy('DealerNameDesc'); this.setState({ sortDropdownAnchorEl: null }); }}>Bedrift - alfabetisk synkende</MenuItem>
                                <ListSubheader sx={{ fontSize: "16px" }}>Pris</ListSubheader>
                                <MenuItem sx={{ fontSize: "16px" }} value="Price" onClick={() => { this.setOrderBy('Price'); this.setState({ sortDropdownAnchorEl: null }); }}>Pris - høy - lav</MenuItem>
                                <MenuItem sx={{ fontSize: "16px" }} value="PriceAsc" onClick={() => { this.setOrderBy('PriceAsc'); this.setState({ sortDropdownAnchorEl: null }); }}>Pris - lav - høy</MenuItem>
                            </Menu>
                        </div>
                    </div>
                    

                    // Inside the render method, after the partDetailsSearchResults div
                    <div className='partDetailsSearchResults'>
                        {this.state.SearchResults.map((object, i) => <SearchResultItem firmanavn={this.state.Firmanavn} key={object.StorageId} id={object.StorageId} firmnavn={this.data.Firmanavn} data={object} siteUrl={this.props.SiteUrl} />)}
                    </div>

                    aaa
                    <Pagination
                        count={this.state.TotalResults}
                        page={this.state.Filters.start}
                        onChange={(event, value) => this.bah(null, 'start', event, value)}
                        color="primary"
                        showFirstButton
                        showLastButton
                        size="large"
                    />
                </div>
            </div>);
    }
}




